export function useClipboard() {
    const isCopied = ref(false);
    let copyTimeout: NodeJS.Timeout | null = null;

    const copyToClipboard = async (text: string, options?: {
        successMessage?: string;
        errorMessage?: string;
        resetDelay?: number;
    }) => {
        const {
            successMessage = 'Скопировано в буфер обмена',
            errorMessage = 'Не удалось скопировать',
            resetDelay = 2000
        } = options || {};

        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(text);
                isCopied.value = true;
            } else {
                throw new Error('Clipboard API not available');
            }

            // Show toast notification
            document.dispatchEvent(new CustomEvent('show-toast', {
                detail: {
                    text: successMessage,
                },
                bubbles: true
            }));

            // Reset copied state after delay
            if (copyTimeout) {
                clearTimeout(copyTimeout);
            }
            copyTimeout = setTimeout(() => {
                isCopied.value = false;
            }, resetDelay);
        } catch (err) {

            // Fallback для старых браузеров
            try {
                const textArea = document.createElement('textarea');
                textArea.value = text;
                textArea.style.position = 'fixed';
                textArea.style.left = '-999999px';
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);

                isCopied.value = true;

                // Show toast notification
                document.dispatchEvent(new CustomEvent('show-toast', {
                    detail: {
                        text: successMessage,
                    },
                    bubbles: true
                }));

                if (copyTimeout) {
                    clearTimeout(copyTimeout);
                }
                copyTimeout = setTimeout(() => {
                    isCopied.value = false;
                }, resetDelay);
            } catch (fallbackErr) {
                console.error('Fallback copy failed: ', fallbackErr);

                // Show error toast
                document.dispatchEvent(new CustomEvent('show-toast', {
                    detail: {
                        text: errorMessage,
                        type: 'error'
                    },
                    bubbles: true
                }));
            }
        }
    };

    const cleanup = () => {
        if (copyTimeout) {
            clearTimeout(copyTimeout);
        }
    };

    return {
        isCopied,
        copyToClipboard,
        cleanup
    };
}
